<div class="container-fluid non-transparent-header px-0">
  <div class="row mx-auto">
    <div class="author text-center w-100 q-page-header">
      <ng-container *ngIf="isDesktop">
        <page-header [title]="pageTitle"></page-header>
      </ng-container>
    </div>

    <div class="my-4 mx-auto {{ isDesktop ? 'q-page-container w-80' : 'q-page-container-mobile'}}" [class.no-outfit]="noOutfit">
      <ng-container *ngIf="!noOutfit">
        <div *ngIf="isLoggedIn && !userId" class="flex justify-content-end mb-3">
          <p-button styleClass="p-button-link" label="Style An Outfit" routerLink="new" />
        </div>
        <uikit-list [itemMeta]="productMeta" [fetchItems]="fetchProducts.bind(this)" class="mt-3"
          loadingText="Looking for your outfits, give us a sec…" displayEmptyMessage=""
          (onItemClick)="openOutfitMaker($event)" (onLinkBtnClick)="copyLink($event)">
        </uikit-list>
      </ng-container>
    
      <div class="no-record-message mt-0" *ngIf="noOutfit">
        <img src="./assets/img/prohibited-outfits.svg" alt="no-outfits" height="150" width="auto" />
        <span class="mt-3 mb-2">No Outfits Found!!!</span>
        <p-button *ngIf="isLoggedIn && !userId" styleClass="p-button-link" label="Style an Outfit" routerLink="new" />
      </div>
    </div>
  </div>
</div>